import styled from 'styled-components';
import * as React from 'react';
import { Checkbox, Table, Nav, NavItem } from 'react-bootstrap';

export const TabWrapper = styled.div`
    width: 100%;
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    min-height: 55vh;
    padding: 10px;
    background-color: #FFF;
    margin-bottom: 10px;
`;

interface INavItemProps {
    tabWidth?: string,
    inactive?: boolean
}


export const NavItemWrapper = styled(NavItem) <INavItemProps>`
    // & > a {
    //     width: ${(p: INavItemProps) => p.tabWidth ? p.tabWidth + 'px !important' : '150px'};
    // }

    // & > a {
    //     min-width: 140px;
    // }

    & > a {
        background-color: ${(p: INavItemProps) => p.inactive ? 'lightgrey !important' : 'white !important'};
        color: black !important;
    }
`;

export const NavWrapper = styled(Nav)`
    & > li > a {
        font-size: 14px;
        font-weight: 500;
        background-color: white;
        color: black;
        // width: 160px;
        text-align: center;
        border-width: 1px 1px 0px 1px;
        border-style: solid;
        border-color: #ddd;
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: #337ab7;
        color: white;
    }

    & > li.active > a {
        font-size: 16px;
        line-height: 20px;
        background-color: #337ab7;
        color: white;
    }

    @media (max-width: 1823px) {
        & > li > a {
            font-size: 13px;
            line-height: 20px;
        }

        & > li.active > a {
            font-size: 14px;
            line-height: 20px;
        }
    }
`;

export const Styles = styled.div`
    .table {
        display: inline-block;
        border-spacing: 0;
        margin-bottom: 0px;

        .th,
        .td {
            margin: 0;
            padding: 0.5rem;
            text-align: center;
            // border-bottom: 1px solid black;
            // border-right: 1px solid black;

            :last-child {
                // border-right: 1px solid black;
            }
        }

        .td.actions {
            padding: 0.3rem;
        }

        .th.th-donor {
            background-color: #ddd;
            border-color: white white lightblue white;
            border-width: 1px 1px 0px 0px;
            border-style: solid;
            border-collapse: collapse;
            padding: 0.7rem 0.5rem;
            height: 32px;
            font-weight: 700;
        }
    }

    .tr > .td {
        border-color: #ddd;
        border-width: 1px 1px 1px 0px;
        border-style: solid;
    }

    .tr:last-child .td {
        border-color: #ddd;
        border-width: 0px 1px 1px 0px;
        border-style: solid;
    }

    .th-donor-main {
        background-color: #2D6CA2;
        color: #fff;
    }

    div[role='rowgroup'] > div.potential-donors-paired-donor {
        border-width: 1px 1px 0px 1px;
        border-color: #ccc #ccc #ccc #ccc;
        border-style: solid;
        //overflow: auto scroll !important;
    }

    div[role='rowgroup'] > div {
        border-width: 1px;
        border-color: #ccc #ccc #ccc #ccc;
        border-style: solid;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        overflow: auto scroll !important;
    }

    .tr.paired-donor {
        background-color: darkgreen;
        color: white;
    }

    .btn-inverse {
        background-color: #555;
        background-image: linear-gradient(to bottom, #555 0%, #333 100%);
        background-repeat: repeat-x;
        border-color: #999;
        color: #FFF;
        font-weight: bold;
    }
`;

const areEqual = (prevProps: any, nextProps: any) => prevProps.checked === nextProps.checked && prevProps.indeterminate === nextProps.indeterminate;

export const HeaderCheckbox = React.memo(
    styled(Checkbox)({
        fontSize: '1rem',
        margin: '-8px 0 -8px -15px',
        padding: '8px 9px',
        '& svg': {
            width: '24px',
            height: '24px',
        },
        '&:hover': {
            backgroundColor: 'transparent',
        },
    }),
    areEqual
)

export const RowCheckbox = React.memo(
    styled(Checkbox)({
        fontSize: '14px',
        margin: '-7px 0 -8px -7px',
        padding: '5px 9px',
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '& svg': {
            width: 24,
            height: 24,
        },
    }),
    areEqual
)

export const GridWrapper = styled.div`
    // height: 53vh;
    font-family: Roboto;
    margin-bottom: 5px;

    .action-menu {
        overflow: visible;
        border-bottom: none;
        // line-height: 33px;
        border-color: #ccc;
        display: flex;
        align-items: center;
    }

    .action-menu > .ag-react-container {
        width: 100%;
    }

    .action-menu.ag-cell-focus {
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header {
        //background-color: #133366;
        background-color:  #ddd;
        // color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
        font-weight: bold;
    }

    .ag-header-cell {
        display: flex;
        justify-content: center;
    }

    .ag-header-cell > .ag-react-container .customHeaderLabel {
        //color: #fff;
    }

    .ag-floating-top {
        overflow-y: scroll !important;
    }
    
    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        border-right: 1px solid #ccc;
        // overflow-y: scroll !important;
    }

    .ag-center-cols-viewport {
        // overflow-x: hidden;
    }

    .ag-body-horizontal-scroll-viewport {
        overflow-x: auto;
    }
    
    .ag-center-cols-clipper {
        min-height: initial !important;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .ag-cell {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .list-cell {
        border-bottom: none;
        text-align: center;
        // line-height: 36px;
        border-color: #ccc;
        // font-size: 12px;
    }

    span.label {
        line-height: 28px;
        font-size: 85%;
    }

    .list-cell-note {
        border-bottom: none;
        text-align: center;
        // line-height: 36px;
        border-color: #ccc;
        // font-size: 12px;
        background-color: lightgoldenrodyellow;
    }

    .list-cell-small {
        border-bottom: none;
        text-align: center;
        line-height: initial;
        border-color: #ccc;
    }

    .list-cell-full {
        border-bottom: none;
        text-align: center;
        // line-height: 26px;
        border-color: #ccc;
        // font-size: 12px;
    }

    // .list-cell-full > .ag-cell-wrapper > .ag-cell-value {
    //     height: 30px;
    // }

    .list-cell-full > .ag-react-container,
    .list-cell-full > .ag-cell-wrapper,
    .list-cell-full > .ag-cell-wrapper > .ag-cell-value {
        width: 100%;
    }

    .list-other-cell {
        background-color: #DBDBDB;
        color: black;
        border-bottom: none;
        text-align: center;
        line-height: 33px;
        border-color: #B7B7B7;
    }

    .list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        border-color: #eee;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
    }

    .list-header-select-all {
        display: flex;
        justify-content: center;
        align-items: center;
        border-color: #eee;
        border-width: 1px 1px 0px 1px;
        border-style: solid;
    }

    .list-header-select-all > .ag-react-container {
        line-height: 0px;
        padding-top: 3px;
    }

    .th-recipient-top {
        background-color: #2D6CA2;
        color: #FFF;
        border-right: 1px solid white;
    }

    .th-donor-top {
        background-color: #2D6CA2;
        color: #FFF;
    }

    .th-recipient {
        background-color: #ddd;
        border-color: white white #ddd white;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        padding: 0.7rem 0.5rem !important;
        height: 32px;
        font-weight: bold;
    }

    .th-donor {
        background-color: #ddd;
        border-color: white white #ddd white;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        padding: 0.7rem 0.5rem !important;
        height: 32px;
        font-weight: bold;
    }

    .list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-header-row > .ag-header-group-cell > .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
    }

    .react-grid-Row:hover .react-grid-Cell, .react-grid-Row.row-context-menu .react-grid-Cell {
        background-color: lightgoldenrodyellow;
    }

    .ag-icon.ag-icon-asc {
        color: white;
    }

    .ag-icon.ag-icon-desc {
        color: white;
    }

    .customHeaderLabel {
        // margin-left: 5px;
        // float: left;
        text-align: center;
    }

    .customSortDownLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortUpLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortRemoveLabel {
        float: left;
        font-size: 11px;
        margin-left: 3px;
    }

    .active {
        color: cornflowerblue;
    }

    select.review-type {
        padding: 2px 5px;
        height: 24px;
        // line-height: 24px;
    }

    @media (width < 1920px) {
        font-size: 12px;
    }
`;

export const styles: { [key: string]: React.CSSProperties } = {
    recipientInfoStrip: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        columnGap: 15
    },
    recipientInfoItem: {
        display: 'flex',
        alignItems: 'center'
    },
    itemLabel: {
        marginRight: 5,
        fontWeight: 700
    },
    linkButton: {
        padding: 0
    },
    pendingCount: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 25,
        fontWeight: 'bold',
        fontSize: '15px',
        color: '#348834'
    },
};